import ChatContainer from 'app/sm/chat/chat_container'

export default ChatContainer
